import { render } from "./PushNotificationList.vue?vue&type=template&id=4e0a29be"
import script from "./PushNotificationList.vue?vue&type=script&lang=js"
export * from "./PushNotificationList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__